import Validator from './imaios-form-validator/validator';
import SecurityHandler from './imaios-form-security/security.form-handler';
import './password-view.js';
import FormPasswordManager from "@assets/js/imaios-form/FormPasswordManager";
import {TimeManagerService} from "@assets/js/imaios-form/TimeManagerService";

class ImaiosForm {
    /**
     * @param {object} [settings]
     * @param {Element|string} settings.element
     * @param {[]} [settings.validationRules]
     * @param {[]} [settings.securityRules]
     * @param {(form: ImaiosForm) => void} [settings.onsubmit]
     * @param {(form: ImaiosForm) => void} [settings.onchange]
     * @param {(form: ImaiosForm) => void} [settings.onsecurityerror]
     */
    constructor(settings = {})
    {
        this.formPasswordManager = new FormPasswordManager();
        this.submitProcessActive = false;
        this.retrieveForm(settings.element);
        this.onchange = settings.onchange ?? (() => {});

        if (typeof settings.translations === "undefined") {
            if (
                typeof window.imaios !== 'undefined' &&
                typeof window.imaios.translations !== 'undefined'
            ) {
                // copy translations availables from global context
                settings.translations = {
                    ...window.imaios.translations
                };
            }
        }

        this.validator = Validator.create(
            this,
            settings.validationRules || Validator.retrieveRules(this.form),
            settings.translations
        );

        this.security = SecurityHandler.create(
            this,
            settings.securityRules || SecurityHandler.retrieveRules(this.form)
        );

        this.form.addEventListener('submit', async event => {
            event.preventDefault();
            event.stopImmediatePropagation();

            try {
                if (this.submitProcessActive === false) {
                    this.lockSubmit();

                    const isValid = await this.validator.check();
                    if (isValid === false) {
                        return this.unlockSubmit();
                    }

                    await this.generateFormDataForPOST();

                    const isOk = await this.security.apply();
                    if (isOk === false) {
                        if (typeof settings.onsecurityerror === 'function') {
                            try {
                                settings.onsecurityerror(this);
                            }
                            catch (err) {
                                console.error(err);
                            }
                        }

                        return this.unlockSubmit();
                    }

                    if (typeof settings.onsubmit === 'function') {
                        try {
                            await settings.onsubmit(this);
                        } catch(e) {
                            console.error(e);
                        }
                        this.unlockSubmit();
                    } else {
                        this.form.submit();
                        return true;
                    }
                }
            } finally {
                // able to reset the instance which able to save the timestamp
                // reset this instance singleton to have a new timestamp when you submit new time the form
                if (TimeManagerService.instance !== null && typeof TimeManagerService.instance !== 'undefined') {
                    TimeManagerService.instance.deleteInstance();
                }
            }
        });
    }

    async generateFormDataForPOST()
    {
        if (this.getMethod().toLowerCase() === 'post') {
            const formData = new FormData(this.form);
            const data = new URLSearchParams();
            for (const pair of formData) {
                if (this.formPasswordManager.canEncrypt(pair[0])) {
                    data.append(pair[0], await this.formPasswordManager.encrypt(pair[1], pair[0]));
                } else {
                    data.append(pair[0], pair[1]);
                }
            }
            this.form.options.body = data;
        }
    }

    getMethod()
    {
        return this.form.getAttribute('method') || 'GET';
    }

    getAction()
    {
        return this.form.getAttribute('action');
    }

    async getBody()
    {
        const body = {};
        const inputElements = Array.from(this.form.querySelectorAll('[name]'));
        for (const element of inputElements) {
            if (element.value !== "") {
                if (element.getAttribute('type') === 'checkbox') {
                    if (element.checked) {
                        body[element.getAttribute('name')] = element.value;
                    }
                } else {
                    if (this.formPasswordManager.canEncrypt(element.getAttribute('name'))) {
                        body[element.getAttribute('name')] = await this.formPasswordManager.encrypt(element.value, element.getAttribute('name'));
                    } else {
                        body[element.getAttribute('name')] = element.value;
                    }
                }
            }
        }

        return body;
    }

    getForm()
    {
        return this.form;
    }

    getFormID()
    {
        return this.form_id;
    }

    lockSubmit()
    {
        this.submitProcessActive = true;
        Array.from(this.form.querySelectorAll('[type="submit"], button[type="submit"]')).forEach(elt => {
            elt.setAttribute('disabled', true);
            elt.style.pointerEvents = 'none';
        });
    }

    unlockSubmit()
    {
        this.submitProcessActive = false;
        Array.from(this.form.querySelectorAll('[type="submit"], button[type="submit"]')).forEach(elt => {
            elt.removeAttribute('disabled');
            elt.style.pointerEvents = 'auto';
        });
    }


    retrieveForm(elt_id)
    {
        if (typeof elt_id === 'string') {
            this.form = document.getElementById(elt_id);
            this.form_id = elt_id;
        } else {
            this.form = elt_id;
            this.form_id = this.form.getAttribute('id');
        }
        if (this.form instanceof HTMLFormElement) {
            this.form.options = { method: this.getMethod() }

            // listen for both input and change events to cover all input types
            this.form.addEventListener('change', () => {
                this.onchange(this);
            });
            this.form.addEventListener('input', () => {
                this.onchange(this);
            });
        }
    }
}

window.ImaiosForm = ImaiosForm;

if (window.imaios) {
    window.imaios.pubsub.publish('imaios-form-is-ready');
}
export default ImaiosForm;
